import styled, { css } from 'styled-components';

export const WrapperIconTable = styled.div<{ disabled?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: ${(props) => (props.disabled ? 'unset' : 'pointer')};
    width: 100%;
    height: 100%;

    .rdt_TableCell {
        width: 100%;
        justify-content: center;
    }
`;

export const TitleIconTable = styled.span`
    ${({ theme }) => css`
        color: ${theme.colors.black};
        font-size: ${theme.fontSizes.default};
    `}
`;
